import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  StoreInchargeSpecificProductList
} from "../../Repository/Api";
import { errorMsg } from "../Toastify";

const StoreProductspecificview = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    getSpecificProduct();
  }, []);

  const [specificProduct, setSpecificProduct] = useState({});
  const [active, setActive] = useState(0);
  const links = ["Product Details", "Purchased History"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getSpecificProduct = async () => {
    const response = await StoreInchargeSpecificProductList(id, token);
    if (response && response.statusCode === 200) {
      setSpecificProduct(response?.data);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6 p-0">
                <h6 className="headertext">
                  <h6 className="headertext">{first_name + ' ' + last_name}</h6>
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Product List
                </h6>
                <div className="row">
                  <div className="col-lg-4 mx-auto ms-auto">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                {active === 0 && (
                  <>
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>1. Product Name</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{specificProduct?.product_details?.name}</h6>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>2. Product Specification</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {specificProduct?.product_details?.specification}
                        </h6>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>3. Product Quantity</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{specificProduct?.product_details?.quantity}</h6>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>4. Minimum Quantity Available</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {
                            specificProduct?.product_details
                              ?.minimum_quantity_available
                          }
                        </h6>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>5. Max Quantity Ordered</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {
                            specificProduct?.product_details
                              ?.max_quantity_ordered
                          }
                        </h6>
                      </div>
                    </div>
                  </>
                )}
                {active === 1 && (
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">S.NO</th>
                        <th scope="col">Purchaser Name</th>
                        <th scope="col">Purchased Date</th>
                        <th scope="col">Purchased Quantity</th>
                        <th scope="col">Unit Price</th>
                        <th scope="col">Total Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {specificProduct?.purchase_history?.length > 0 ? (
                        specificProduct?.purchase_history &&
                        specificProduct?.purchase_history?.map(
                          (product, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {product?.purchased_from
                                  ? product?.purchased_from
                                  : "-"}
                              </td>
                              <td>
                                {moment(product?.purchased_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td>
                                {product?.quantity ? product?.quantity : "-"}
                              </td>
                              <td>
                                {product?.per_unit_price
                                  ? product?.per_unit_price
                                  : "-"}
                              </td>
                              <td>
                                {product?.total_price
                                  ? product?.total_price
                                  : "-"}
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StoreProductspecificview;
